/**
 * removes nested structure, to simplify accessing small queries
 * that don't need pageInfo, etc.
 * @param {Object} object - Shopify GraphQL Product query response
 * @returns
 */
export default function unwrapNodes(object) {
  // These keys will be unwrapped unless there are other keys present
  const unwrapKeys = [
    "references",
    "reference",
    "edges",
    "node",
    "nodes",
    "value",
    "data",
    "metaobject",
  ];

  if (!object || typeof object !== "object") return object;

  if (object instanceof Array) {
    return object.map(unwrapNodes);
  }

  Object.entries(object).forEach(([key, value]) => {
    const unwrapped = unwrapNodes(value);
    object[key] = unwrapped;
  });

  let value = undefined;

  if (Object.keys(object).length === 1) {
    unwrapKeys.forEach((key) => {
      if (key in object) {
        value = object[key];
      }
    });
  }

  if (value !== undefined) return value;

  return object;
}
